import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { Dispatch } from 'redux';
import { StoreState } from '@mm/state/store-interfaces';
import Select from '../../../../../common/components/MainSelect/MainSelect';
import RssFeedModel from '@mm/state/model/RssFeedModel';
import { WEBVIEW_HEIGHT_VALUES } from './constants';
import RssFeedCRUDActions from '@mm/state/actions/RssFeedCRUDActions';
import './RssFeedDetails.scss';

type PropsFromDispatch = ReturnType<typeof mapDispatchToProps>;

type OuterProps = {
  feed: RssFeedModel;
  chatbotId: number;
};

type Props = PropsFromDispatch & OuterProps;

const WebviewHeightTextInput = (props: Props) => {
  const {
    feed: { webviewHeightRatio },
    updateFeed,
  } = props;

  return (
    <div className="feed-details__input-container">
      <div className="feed-details__field-title">Webview Height</div>
      <Select onChange={updateFeed} value={webviewHeightRatio}>
        {Object.keys(WEBVIEW_HEIGHT_VALUES).map(key => (
          <option value={key} key={key}>
            {WEBVIEW_HEIGHT_VALUES[key]}
          </option>
        ))}
      </Select>
    </div>
  );
};

const mapDispatchToProps = (dispatch: Dispatch<StoreState>, ownProps) => ({
  updateFeed: e => {
    const { feed, chatbotId } = ownProps;
    const webviewHeightRatio = e.target.value;

    if (webviewHeightRatio) {
      const nextLabel = 'nextLabel';
      const newFeed = Object.assign({}, feed, { webviewHeightRatio });
      return dispatch(RssFeedCRUDActions.update(chatbotId, newFeed));
    }
    return null;
  },
});

const enhance = compose<PropsFromDispatch, OuterProps>(
  connect(null, mapDispatchToProps),
);

export default enhance(WebviewHeightTextInput);
